<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="row col-md-12" v-else>
      <div class="col-md-7">
        <div>
          <div>
            <b-card>
              <b-card-title
                >Integralização Voluntária - Matrícula:
                {{ this.$store.state.nrMatricula }}</b-card-title
              >
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Valor *">
                    <money
                      v-model="valorCota"
                      v-bind="money"
                      @input="calculaQuantidadeCota"
                      class="form-control text-end text-dark fw-bold"
                    >
                    </money>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <b-form-group label="Valor Unitário">
                    <money
                      v-model="valorCotaUnitario"
                      v-bind="money"
                      class="form-control text-end text-dark fw-bold"
                      disabled
                    >
                    </money>
                  </b-form-group>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <b-form-group
                      class="mb-3 text-end"
                      label="Quantidade de Cotas"
                    >
                      <b-form-input
                        v-model="quantidadeCotas"
                        class="form-control text-end text-dark fw-bold"
                        :disabled="true"
                        type="text"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </div>
              <div class="row">
                <span>Forma de Pagamento</span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    style="fill: #77B6A8; width: 20px; height: 20px;"
                  >
                    <path d="M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.8C231.1-7.6 280.3-7.6 310.6 22.8L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.8L22.8 310.6C-7.6 280.3-7.6 231.1 22.8 200.8L80.8 142.7H112.6z"/>
                  </svg> PIX
                </span>
              </div>
              <div class="row">
                <div class="mt-1 text-end">
                  <b-button
                    class="mt-1 me-1 font-size-13"
                    :variant="loadingConfirmar || formatarNumero(quantidadeCotas) < 100 ? 'secondary' : 'success'"
                    @click="confirmarValor(valorCota)"
                    :disabled="loadingConfirmar || formatarNumero(quantidadeCotas) < 100"
                  >
                    Confirmar
                    <b-spinner
                      class="ms-2"
                      small
                      variant="primary"
                      v-if="loadingConfirmar"
                    ></b-spinner>
                  </b-button>
                </div>
              </div>
            </b-card>
          </div>
          <div>
            <div class="text-center" v-if="loadingTabela">
              <b-spinner class="ms-2" variant="primary"></b-spinner>
            </div>
            <b-card v-if="!escondeTabela">
                <b-card-title>Extrato de Integralização Voluntária</b-card-title>
                <div class="row">
                  <b-table
                    responsive="sm"
                    :items="dadosIntegralizacao"
                    :fields="camposIntegralizacao"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @update:currentPage="currentPage = $event"
                    @filtered="onFiltered"
                    striped
                  >
                        <template #cell(STATUS)="data">
                            <div class="d-flex flex-column text-start">
                                <div>
                                    <span
                                        class="badge badge-pill font-size-12"
                                        :class="{
                                            'badge-soft-success': data.item.STATUS === 'Pagamento Realizado',
                                            'badge-soft-primary': data.item.STATUS === 'Pagamento Pendente',
                                            'badge-soft-secondary': data.item.STATUS === 'Pagamento Expirado',
                                            'badge-soft-danger': data.item.STATUS === 'Pagamento Cancelado',
                                        }"
                                    >
                                        {{ data.item.STATUS }}
                                    </span>
                                </div>
                                <span
                                    v-if="data.item.STATUS === 'Pagamento Pendente'"
                                    class="fw-lighter fst-italic mt-1"
                                    style="font-size: 10px"
                                >
                                    Pag esta sujeito a <br />
                                    confirmação até 72h
                                </span>
                            </div>
                        </template>
                        <template #cell(options)="data">
                            <div v-if="data.item.STATUS === 'Pagamento Pendente'">
                                <b-button
                                    size="sm"
                                    variant="custom"
                                    :style="{ 'background-color': '#556ee6', 'color': '#fff' }"
                                    @click="getQrCode(dadosIntegralizacao[data.index].SQINTEGRALIZACAO)"
                                    :disabled="loadingQrCode"
                                    :data-id="dadosIntegralizacao[data.index].SQINTEGRALIZACAO"
                                    v-if="data.item.STATUS !== 'Pagamento Realizado'"
                                >
                                    QR Code
                                    <b-spinner
                                        class="ms-2"
                                        small
                                        variant="primary"
                                        v-if="loadingQrCode"
                                    ></b-spinner>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      aria-controls="my-table"
                    ></b-pagination>
                </div>
            </b-card>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="text-center" v-if="loadingQrCode">
          <b-spinner class="ms-2" variant="primary"></b-spinner>
        </div>
        <b-card v-if="!escondeQRCode">
          <div class="d-flex justify-content-center text-center">
            <img :src="qrCodeImage" alt="" :style="{
                marginBottom: '15px',
                borderRadius: '10px',
                border: '2px solid #07331A',
              }"
            />
          </div>
          <div class="row text-center">
            <span class="font-size-16"
              ><strong>{{
                $tools.converteReal(selectedId.VLINTEGRALIZACAO)
              }}</strong></span
            >
          </div>
          <div class="row">
            <div class="col-md-12 d-flex justify-content-center">
              <textarea id="text-copiaCola" v-model="textAreaData" style="width: 80%; height:90px; margin-top: 10px; margin-bottom: 15px; resize: none;" readonly></textarea>
            </div>
            <div id="copiaQrCode" class="d-none">
              {{ informacoesPagamento.pixCopiaECola }}
            </div>
            <div class="col-md-12 d-flex justify-content-center">
              <b-button
                :variant="buttonVariant"
                :style="buttonStyle"
                @click="copiarConteudo"
                style="margin-bottom: -10px;"
              >
                Copiar Código do QR Code <i class="mdi mdi-content-copy"></i>
              </b-button>
            </div>
          </div>
          <div class="row mt-3">
            <div class="d-flex m-2">
              <!-- <div class="col-md-3">
                <span><strong>Chave Pix </strong></span>
              </div> -->
              <!-- <div class="col-md-9">
                <span>{{ informacoesPagamento.chave }}</span>
              </div> -->
            </div>
            <div class="d-flex m-2">
              <div class="col-md-3">
                <strong>Nome </strong>
              </div>
              <div class="col-md-9">
                <span
                  >COOPERATIVA DE TRABALHO DOS PROFISSIONAIS DE AGRONOMIA
                  LTDA</span
                >
              </div>
            </div>
            <div class="d-flex m-2">
              <div class="col-md-3">
                <strong>CNPJ </strong>
              </div>
              <div class="col-md-9">
                <span>72.042.799/0001-90</span>
              </div>
            </div>
            <div class="d-flex m-2">
              <div class="col-md-3">
                <strong>Banco </strong>
              </div>
              <div class="col-md-9">
                <span>Banco do Brasil - <strong>Ag.</strong> 3409-6 <strong>C/C</strong> 75.505-2</span>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import { find } from "underscore";
import { Money } from "v-money";
export default {
  components: {
    PageHeader,
    Money,
  },
  data() {
    return {
      title: "Integralização Voluntária",
      items: [
        {
          text: "Conta Capital",
          active: false,
          href: "/cooperado/contaCapital",
        },
        {
          text: "Integralização Voluntária",
          active: true,
        },
        {
          text: this.$store.state.nrMatricula,
          active: true,
        },
        console.log("this.$store.state.me", this.$store.state.me),
      ],
      textAreaData: "",
      money: {
        decimal: ",",
        masked: false,
        prefix: "R$ ",
        precision: 2,
        thousands: ".",
      },
      loading: false,
      loadingConfirmar: false,
      valorCota: "",
      valorCotaUnitario: "",
      quantidadeCotas: 0,
      loadingTabela: false,
      escondeTabela: true,
      camposIntegralizacao: [
        {
          key: "DTLCTO",
          label: "Data",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value).substr(0, 10);
          },
        },
        {
          key: "QTCOTAS",
          label: "Qtde Cotas",
          class: "alinharCelulaDireita",
        },
        {
          key: "VLINTEGRALIZACAO",
          label: "Valor",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "VLSALDO",
          label: "Saldo",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "STATUS",
          label: "Status",
          class: "alinharCelulaDireita",
        },
        {
          key: "options",
          label: "",
        },
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      dadosIntegralizacao: [],
      escondeQRCode: true,
      qrCode: "",
      informacoesPagamento: "",
      id: "",
      loadingQrCode: false,
      corBotaoCopiarQrCode: "success",
      buttonClicked: false,
      cdPessoa: this.$store.state.me.cd_pessoa.toString(),
    };
  },
  async created() {
    this.$tools.fecharMenu();
    await this.buscaValorCotaUnitaria();
    await this.buscarTabelaIntegralizacao();
  },

  computed: {
      buttonVariant() {
        return this.buttonClicked ? 'secondary' : 'success';
      },
      buttonStyle() {
        return this.buttonClicked
          ? { 'background-color': '#6c757d', 'color': '#fff' }
          : { 'background-color': '#07331A', 'color': '#fff' };
      },
  },

  methods: {
    async buscaValorCotaUnitaria() {
      this.loading = true;
      try {
        const response = await this.$http.get(
          "api/contaCorrente/contaCapital/getValorCota/" +
            this.$store.state.nrMatricula
        );
        this.valorCotaUnitario = response.data.data.valorCota;
      } catch (error) {
        this.$tools.alerta(error.response.data.message, "error");
      } finally {
        this.loading = false;
      }
    },
    async confirmarValor() {
      this.loadingConfirmar = true;
      this.loadingQrCode = true;
      const dadosBancario = {
        calendario: {
          expiracao: 180,
        },
        devedor: {
          cnpj: this.$store.state.me.nr_cpf.toString(),
          nome: this.$store.state.me.nm_razao,
        },
        valor: {
          original: this.valorCota,
        },
        // chave: "9e881f18-cc66-4fc7-8f2c-a795dbb2bfc1",
        // chave: "72042799000190", // Produção
        chave: "95127446000198",
        solicitacaoPagador: "Integralização Voluntária.",
        infoAdicionais: [
          {
            nome: "Tipo de Depósito",
            valor: "Depósito de Integralização Voluntária",
          },
          {
            nome: "Código do Cooperado",
            valor: this.cdPessoa,
          },
        ],
      }
      const dados = {
        sq_usuario: this.$store.state.me.sq_usuario,
        nr_matricula: this.$store.state.nrMatricula,
        qt_cotas: this.quantidadeCotas,
        valor: this.valorCota,
      };
      try {
        const response = await this.$http.post(
          "api/contaCorrente/contaCapital/verificarValor",
          dados
        );
        if (response.status == 200) {
          try {
            const qrCode = await this.$http.post(
          "api/transacaoBancaria/pix/criarCobranca",
          { ...dados, ...dadosBancario }
          );
            if (qrCode.status == 200) {
              this.$tools.alerta("Integralização realizada", "success");
              this.buscarTabelaIntegralizacao();
            }
          } catch (error) {
            this.$tools.alerta(error.qrCode.data.message, "error");
          }
        }
      } catch (error) {
        this.$tools.alerta(error.response.data.message, "error");
      } finally {
        this.loadingConfirmar = false;
        this.loadingQrCode = false;
        this.valorCota = 0;
        this.quantidadeCotas = 0;
        this.escondeQRCode = true;
      }
    },

    async buscarTabelaIntegralizacao() {
      this.loadingTabela = true;
      const dados = this.$store.state.me.sq_usuario + "/" + this.$store.state.nrMatricula;
      try {
        const response = await this.$http.get(
          "api/contaCorrente/contaCapital/getIntegralizacao/" + dados
        );
        if (response.status == 200) {
          this.dadosIntegralizacao = response.data;
          this.totalRows = response.data.length; // Atualizar totalRows
          this.escondeTabela = false;
          this.loadingTabela = false;
        }
      } catch (error) {
        this.$tools.alerta(error.response, "error");
      }
    },
    async getQrCode(id){
        this.loadingQrCode = true;
        this.buttonClicked = false;
        this.selectedId = find(this.dadosIntegralizacao, (item) => {
            return item.SQINTEGRALIZACAO == id;
        });
        try {
            const response = await this.$http.get(
                "api/transacaoBancaria/pix/getQRCode/" + this.selectedId.SQINTEGRALIZACAO,
                { responseType: 'blob' }
            );
            if (response.status == 200) {
                console.log("response", response.data)
                const reader = new FileReader();
                reader.onload = e => {
                    this.qrCodeImage = e.target.result;
                    this.escondeQRCode = false;
                };
                reader.readAsDataURL(response.data);
                try {
                  const response2 = await this.$http.get(
                    "api/transacaoBancaria/pix/copiaCola/" + this.selectedId.SQINTEGRALIZACAO,
                  );
                  if (response2.status == 200) {
                    this.textAreaData = response2.data;
                  }
                } catch (error) {
                  this.$tools.alerta(error.response, "error");
                }
            }
        } catch (error) {
            this.$tools.alerta(error.response, "error");
        } finally {
            this.loadingQrCode = false;
        }
    },
    calculaQuantidadeCota() {
      const quantidadeCotas = Math.floor(
        parseFloat(this.valorCota) / parseFloat(this.valorCotaUnitario)
      );
      this.quantidadeCotas = quantidadeCotas >= 1 ? quantidadeCotas : 0;
    },
    formatarNumero(numero) {
      let numeroString = String(numero);
      let partes = numeroString.split(".");
      return (
        partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (partes[1] ? "." + partes[1] : "")
      );
    },
    copiarConteudo() {
      const copiarQrCode = document.getElementById("copiaQrCode");
      const textarea = document.getElementById("text-copiaCola");
      if (copiarQrCode && textarea) {
        textarea.select();
        document.execCommand("copy");
        this.$tools.alerta("Conteúdo copiado com sucesso", "success");
        this.buttonClicked = true;
      } else {
        this.$tools.alerta("Elemento não encontrado.", "error");
      }
    },
    onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
    },
  },
};
</script>
